import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';

const dropDownHeader = els => <div className="dropdown-header">{els}</div>;

const DropdownItem = props => {
  const { active, as, children, disabled, divider, header, icon, iconRight, to, onClick } = props;

  if (divider) return <div className="dropdown-divider" />;

  const cn = classNames({
    'dropdown-item': !header,
    'dropdown-header': header,
    active,
    disabled
  });

  const Component = header ? 'div' : as;

  const els = [];
  if (icon && !iconRight) els.push(<Icon key={icon} className={icon} />);
  els.push(children);
  if (icon && iconRight) els.push(<Icon key={icon} className={`${icon} mr-0 ml-auto`} />);

  if (header) {
    return dropDownHeader(els);
  }

  const handleClick = event => {
    if (disabled) {
      event.preventDefault();
      return;
    }

    if (onClick) onClick(event);
  };

  return (
    <Component to={to} className={cn} onClick={e => handleClick(e)}>
      {els}
    </Component>
  );
};

DropdownItem.propTypes = {
  active: PropTypes.bool,
  as: PropTypes.elementType,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  header: PropTypes.bool,
  icon: PropTypes.string,
  iconRight: PropTypes.bool,
  to: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(null)])
};
DropdownItem.defaultProps = {
  active: false,
  as: 'button',
  children: '',
  disabled: false,
  divider: false,
  header: false,
  icon: '',
  iconRight: false,
  to: '',
  onClick: null
};

export default DropdownItem;
